export enum LabInvestigationType {
    Default = null,
    Collect = 1,
    Accept = 2,
}
